import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import { Dropdown} from "semantic-ui-react";
import {api} from '../../../api';

class CourierSelector extends Component {
    constructor() {
        super();
        this.state = {
            options: [
            ]
        }
    }

    componentDidMount() {
        api.system.carriers(this.props.jwt).then(res => {
            this.setState({
                options: res.data
            })
        })
    }

    handleAddition = (e, { value }) => {
        this.setState({
          options: [{ text: value, value }, ...this.state.options],
        })
    }

    render() {
        const {name, selectedValues, onValueChange} = this.props;
        return (
            <div style={{marginBottom: '1em'}}>
                <label style={{
                    display: 'block',
                    margin: '0 0 .28571429rem 0',
                    color: 'rgba(0,0,0,.87)',
                    fontSize: '.92857143em',
                    fontWeight: 700,
                    textTransform: 'none'
                }}>{name}</label>
                <Dropdown 
                    value={selectedValues}
                    allowAdditions
                    onAddItem={this.handleAddition}
                    onChange={(e, data) => onValueChange(e, data)}
                    fluid selection options={this.state.options} search/>
            </div>
        );
    }
}

CourierSelector.propTypes = {
    name: PropTypes.string.isRequired,
    selectedValues: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    jwt: PropTypes.string.isRequired
};

export default CourierSelector;


// WEBPACK FOOTER //
// ./src/components/utils/searches/CourierSelector.js